import * as React from 'react';
import type { SVGProps } from 'react';
const SvgStreamlineStacks = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={20}
    height={20}
    fill="none"
    viewBox="0 0 20 20"
    {...props}
  >
    <mask
      id="a"
      width={20}
      height={20}
      x={0}
      y={0}
      maskUnits="userSpaceOnUse"
      style={{
        maskType: 'alpha',
      }}
    >
      <path fill="#D9D9D9" d="M0 0h20v20H0z" />
    </mask>
    <g mask="url(#a)">
      <path
        fill="currentColor"
        d="M10 10.833a1.4 1.4 0 0 1-.667-.166l-7-3.5a.74.74 0 0 1-.312-.278.73.73 0 0 1-.104-.385q0-.212.104-.39a.73.73 0 0 1 .312-.28l7-3.5A1.45 1.45 0 0 1 10 2.166a1.4 1.4 0 0 1 .667.166l7 3.5q.208.104.312.278.105.173.104.386 0 .21-.104.389a.73.73 0 0 1-.312.28l-7 3.5a1.44 1.44 0 0 1-.667.167m0-1.52L15.646 6.5 10 3.688 4.354 6.5zm0 3.5 6.5-3.23.323-.083q.323 0 .542.219a.73.73 0 0 1 .218.535.728.728 0 0 1-.417.663l-6.5 3.25a1.44 1.44 0 0 1-.666.166 1.4 1.4 0 0 1-.667-.166l-6.5-3.25a.73.73 0 0 1-.312-.279.74.74 0 0 1-.104-.388q0-.318.215-.534a.73.73 0 0 1 .701-.19q.08.024.167.057zm0 3.5 6.5-3.23.323-.083q.323 0 .542.219a.73.73 0 0 1 .218.535.728.728 0 0 1-.417.663l-6.5 3.25a1.44 1.44 0 0 1-.666.166 1.4 1.4 0 0 1-.667-.166l-6.5-3.25a.73.73 0 0 1-.312-.279.74.74 0 0 1-.104-.388q0-.318.215-.534a.73.73 0 0 1 .701-.19q.08.024.167.057z"
      />
    </g>
  </svg>
);
export default SvgStreamlineStacks;
